import SSPARepresentativeTableContainer from './SSPARepresentativeTableContainer';

export default SSPARepresentativeTableContainer;